<template>
    <div class="">
        


    </div>
</template>

<script>
export default {
    namme: 'NotFound',
    data(){
        return {
            row: {
                //
            },
            
        }
    },
    mounted() {},
}
</script>
